import { Formik } from 'formik';
import { useState, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBackIosNew } from 'react-icons/md';
import { placeSchema } from '../../../../../constants';
import { DAV_APIS } from '../../../../../adapters';
import { Alert } from '../../../../commons';
import PlaceForm from '../PlaceForm';
import { Button } from '../../../../ui/Button';

const NewPlacePage: FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submitHandler = async (values: any) => {
    setLoading(true);
    try {
      const data = {
        name: values.name,
        descriptionTitle: values.descriptionTitle,
        description: values.description,
        location: values.location,
        country: values.country,
        file: values.file,
        blocks: values.blocks,
      };
      const res = await DAV_APIS.place.createPlace(data);
      setLoading(false);
      if (res.status === 201) {
        Alert({ variant: 'success', message: 'Place created successfully' });
        navigate('/dashboard/places');
      }
    } catch (error) {
      setLoading(false);
      Alert({ variant: 'error', message: 'Failed to create place, please try again' });
    }
  };

  return (
    <div className='w-full space-y-6 pt-4 pb-10'>
      <div className='flex items-center'>
        <button
          onClick={() => navigate('/dashboard/places')}
          type='button'
          className='flex items-center gap-2 text-gray-500 hover:text-primary-600 transition-colors font-semibold'
        >
          <MdArrowBackIosNew className='w-4 h-4' />
          <span>Back to Places</span>
        </button>
      </div>

      <Formik
        enableReinitialize
        initialValues={{
          name: '',
          descriptionTitle: '',
          description: '',
          location: '',
          country: '',
          file: '',
          imageCover: '',
          blocks: [],
          blockTitle: '',
          blockDescription: '',
        }}
        validationSchema={placeSchema}
        onSubmit={async (values, { resetForm }) => {
          await submitHandler(values);
          resetForm();
        }}
      >
        {({ handleSubmit, values, setFieldValue, dirty, isValid }) => (
          <div className='bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-100 dark:border-gray-700 shadow-sm'>
            <h1 className='text-3xl font-extrabold text-gray-900 dark:text-white mb-8 text-center tracking-tight'>
              Add New Place
            </h1>

            <form onSubmit={handleSubmit} className='w-full'>
              <PlaceForm values={values} setFieldValue={setFieldValue} />
              <div className='flex justify-center mt-10 border-t border-gray-100 dark:border-gray-700 pt-8'>
                <Button
                  type='submit'
                  variant='primary'
                  loading={loading}
                  disabled={!dirty || !isValid}
                  className='w-full sm:w-64'
                >
                  Create Place
                </Button>
              </div>
            </form>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default NewPlacePage;
